import FeedBack from './FeedBack.js';

export default FeedBack;